import type { textWidget } from "@/elements/text/text";
import { Shape } from "../shape";
import { ShapeLinedDocument } from "./linedDocument";

export class ShapeDocument extends Shape {
    width = 200;
    height = 148;

    fitText(
        textPart: textWidget,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = width / 2 - 2 * horizontalPadding;
        const allowedHeight = (height * 5) / 6 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY =
            y + textPart.lines[0].textHeight + (height * 5) / 6 / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        new ShapeLinedDocument().draw(x, y, width, height, false);
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" viewBox="0 0 27 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="${fill}" stroke="${stroke}" d="M25 1H2C1.44772 1 1 1.44772 1 2V14.7627C1 15.0001 1.08399 15.2293 1.24316 15.4054C2.08043 16.3317 4.93484 19.3188 7.52174 20.0217C12.3163 21.3246 14.6513 14.4966 19.4783 15.6739C21.0975 16.0689 22.887 17.3228 24.1813 18.3832C24.8743 18.951 26 18.4675 26 17.5716V2C26 1.44772 25.5523 1 25 1Z"/>
            </svg>
        `;
    }
}
